module.exports = __webpack_public_path__ + "img/cardLayout-05.54787252.png";